var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items"},[_vm._l((_vm.items),function(item,index){return _c('Item',_vm._b({key:index},'Item',item,false))}),_c('router-link',{staticClass:"checkout",attrs:{"to":"/cart"}},[_c('button',[_vm._v("Checkout")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }